<template>
  <div class="natjecatelj no-bg-img">
    <!-- navbar -->
    <Navbar showBackButton></navbar>

    <PanelPokreni v-if="appState == 'round-in-progress'"/>

    <Loading :loadingState="loadingState">
        <Natjecatelj v-for="uid of natjecatelji" :key="uid" :uid="uid" v-on:userdeleted="userDeleted"></Natjecatelj>
        <template v-slot:error>
            <NoResults></NoResults>
        </template>
    </Loading>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Natjecatelj from '../components/Natjecatelj.vue'
import Loading from '../components/common/Loading'
import NoResults from '../components/common/error/NoResults'
import LoadingState from '../utils/loading/LoadingState'
import { ApplicationState } from '../application-state'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'mojegrupenatjecatelj',
    data: function () {
        return {
            loadingState: LoadingState.LOADING,
            natjecatelji: {}
        }
    },
    computed: {
        groupId () {
            return this.$route.params.id
        },
        appState () {
            return this.$store.state.appState
        }
    },
    watch: {
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.loadData()
            }
        }
    },
    methods: {
        async loadData () {
            this.loadingState = LoadingState.LOADING
            try {
                this.natjecatelji = await this.$db.grupe.getGroupNatjecatelji(this.groupId)
                let keys = Object.keys(this.natjecatelji)
                if (keys.length === 0) {
                    this.loadingState = LoadingState.ERROR
                } else {
                    this.loadingState = LoadingState.SUCCESS
                }
            } catch (error) {
                console.error(error)
                this.loadingState = LoadingState.ERROR
            }
        },
        userDeleted (uid) {
            try {
                let natjecateljiKeys = Object.keys(this.natjecatelji)
                for (let key of natjecateljiKeys) {
                    let natjecatelj = this.natjecatelji[key]
                    if (natjecatelj === uid) {
                        this.$delete(this.natjecatelji, key)
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }
    },
    mounted () {
        if (!this.groupId) {
            this.$router.replace({ name: 'home' })
        } else {
            if (this.appState !== ApplicationState.LOADING_DATA) {
                this.loadData()
            }
        }
    },
    components: {
        Navbar,
        Natjecatelj,
        Loading,
        NoResults,
        PanelPokreni
    }
}
</script>

<style lang="scss" scoped>
  .natjecatelj {
    margin-top: 40px;
    padding: 0 15px;
    /deep/ .no-results {
        h5 {
            padding: 15px 0;
        }
        background: white;
        overflow: hidden;
        border-radius: 5px;
    }
  }
  .panel-pokreni {
      margin-bottom: 60px;
  }
</style>
